document.addEventListener('DOMContentLoaded', function () {
    const categoryLinks = document.querySelectorAll('.category-link');
    const navBar = document.querySelector('#site-control');
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    let showCartStickyButton = document.getElementById('js-open-cart-byob');
    let getOpenCartHeader = document.querySelector('.js-open-byob');

    showCartStickyButton.addEventListener('click', openCart);

    function openCart() {
      if (getOpenCartHeader) {
        getOpenCartHeader.click();
      }
    }
    
    categoryLinks.forEach(function (link) {
        link.addEventListener('click', handleCategoryLinkClick);
    });

    function handleCategoryLinkClick(event) {
        event.preventDefault();
        document.body.classList.add('no-scroll');
        document.body.style.marginRight = `${scrollBarWidth}px`;
        navBar.style.marginRight = `${scrollBarWidth}px`;

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }

        setTimeout(resetBodyStyles, 50);
    }

    function resetBodyStyles() {
        document.body.classList.remove('no-scroll');
        document.body.style.marginRight = '0px';
        navBar.style.marginRight = '0px';
    }
});
